"use client";

import { usePathname } from 'next/navigation';
import Script from 'next/script';

const GTAG_ID = process.env.NEXT_PUBLIC_GTAG_ID || 'AW-11496592638';
const CONVERSION_ID = process.env.NEXT_PUBLIC_GTAG_CONVERSION_ID || 'AW-11496592638/WpZgCIPcyusaEP6pgOoq';

export default function GTagHeadScripts() {
  const pathname = usePathname();
  const isThankYouPage = pathname === '/thank-you';

  return (
    <>
      {/* Always load the gtag.js script */}
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`}
        strategy="afterInteractive"
        async
      />
      {/* Base gtag config */}
      <Script
        id="gtag-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${GTAG_ID}');
          `,
        }}
      />
      {/* Only on thank-you page: add conversion event */}
      {isThankYouPage && (
        <Script
          id="gtag-conversion"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `
              gtag('event', 'conversion', {
                'send_to': '${CONVERSION_ID}',
                'value': 1.0,
                'currency': 'INR'
              });
            `,
          }}
        />
      )}
    </>
  );
} 